import React from 'react';
import './BottomModal.css';

interface BottomModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;

  actionLabel?: string;
  onAction?: () => void;
}

const BottomModal: React.FC<BottomModalProps> = ({isOpen, onClose, children, actionLabel, onAction }) => {
  if (!isOpen) return null;

  const showActionButton = Boolean(actionLabel && onAction);

  return (
    <div className={"modalOverlay"} onClick={onClose}>
      <div className={"bottomModal"} onClick={(e) => e.stopPropagation()}>
        <button className={'modalCloseButton'} onClick={onClose}>
          <img src={'/assets/images/ico/ic_close_24.png'} alt={'Close Button'} />
        </button>

        <div className={'modalContent'}>
          {children}
        </div>

        {showActionButton && (
          <div className="btnArea modalActionButtonOverlay">
            <button className={'btnPrimaryTy01 modalActionButton'} onClick={onAction}>
              {actionLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default BottomModal;